import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    position: 'absolute',
    // bottom: 40,
    top: 112,
    right: 16,
    backgroundColor: theme.palette.background.default,
    borderRadius: 32,
    zIndex: 9999,
    padding: 0,
    overflowY: 'scroll',
  },
  content: {
    zIndex: 10,
    backgroundColor: theme.palette.background.default,
    width: '100%',
    height: '100%',
    padding: 8,
    borderRadius: 32,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  floatingButton: {
    height: 48,
    position: 'absolute',
    left: 8,
    top: 8,
    backgroundColor: theme.palette.background.default,
    borderRadius: 32,
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    padding: 8,
  },
}));
